import { OrderDetailPage } from './OrderDetailPage';

export default OrderDetailPage;
